export var ValidationTypeEnum;
(function (ValidationTypeEnum) {
    ValidationTypeEnum[ValidationTypeEnum["Required"] = 1] = "Required";
    ValidationTypeEnum[ValidationTypeEnum["Compare"] = 2] = "Compare";
    ValidationTypeEnum[ValidationTypeEnum["Range"] = 3] = "Range";
    ValidationTypeEnum[ValidationTypeEnum["Regex"] = 4] = "Regex";
    ValidationTypeEnum[ValidationTypeEnum["MinLenght"] = 5] = "MinLenght";
    ValidationTypeEnum[ValidationTypeEnum["MaxLenght"] = 6] = "MaxLenght";
    ValidationTypeEnum[ValidationTypeEnum["RegularExpression"] = 7] = "RegularExpression";
    ValidationTypeEnum[ValidationTypeEnum["Email"] = 8] = "Email";
    ValidationTypeEnum[ValidationTypeEnum["Date"] = 9] = "Date";
})(ValidationTypeEnum || (ValidationTypeEnum = {}));
export var ValidationActivation;
(function (ValidationActivation) {
    ValidationActivation[ValidationActivation["Always"] = 0] = "Always";
    ValidationActivation[ValidationActivation["OnlyWhenAnyFieldFilled"] = 1] = "OnlyWhenAnyFieldFilled";
    ValidationActivation[ValidationActivation["OnlyWhenAllFieldFilled"] = 2] = "OnlyWhenAllFieldFilled";
})(ValidationActivation || (ValidationActivation = {}));
var ValidationRule = /** @class */ (function () {
    function ValidationRule() {
    }
    return ValidationRule;
}());
export { ValidationRule };
var RulesHolder = /** @class */ (function () {
    function RulesHolder() {
    }
    return RulesHolder;
}());
export { RulesHolder };
